import React from "react";
import { Globe, CheckCircle2, XCircle } from "lucide-react";

const hasTag = (scan, t) => (scan.tags || []).includes(t);

export const WebScanCard = ({ scan }) => {
  if (!scan?.scanned_at) return null;
  return (
    <div className="rounded-xl border border-border p-4" data-testid="web-scan">
      <div className="mb-2 flex items-center justify-between">
        <span className="flex items-center gap-2 label-caps text-muted-foreground"><Globe className="h-3.5 w-3.5" /> Scansione sito reale</span>
        <span className="text-[0.65rem] text-muted-foreground">{(scan.scanned_at || "").slice(0, 16).replace("T", " ")}</span>
      </div>
      {!scan.reachable && (
        <div className="flex items-center gap-2 text-sm text-destructive"><XCircle className="h-4 w-4" /> Sito non raggiungibile ({scan.error || scan.status_code})</div>
      )}
      {scan.reachable && scan.protected && (
        <div className="text-sm text-muted-foreground"><span className="text-[#EAB308]">Sito online ma protetto da bot-filter</span> (HTTP {scan.status_code}) — dettagli non leggibili automaticamente. {scan.https ? "HTTPS attivo." : ""} {scan.response_ms} ms.</div>
      )}
      {scan.reachable && !scan.protected && (
        <>
          <div className="mb-2 truncate text-sm">{scan.title || scan.final_url}</div>
          <div className="flex flex-wrap gap-1.5">
            <Chip ok={scan.https} label="HTTPS" />
            <Chip ok={scan.mobile_viewport} label="Mobile" />
            <Chip ok={scan.response_ms < 1500} label={`${scan.response_ms} ms`} />
            <Chip ok={scan.meta_description} label="Meta desc." />
            <Chip ok={scan.has_contact_form || scan.has_phone_link} label="Contatti" />
            <Chip ok={hasTag(scan, "google_ads")} label="Google Ads" />
            <Chip ok={hasTag(scan, "meta_pixel")} label="Meta Pixel" />
            <Chip ok={hasTag(scan, "google_analytics") || hasTag(scan, "google_tag_manager")} label="Analytics" />
            {scan.builder && <span className="rounded-full border border-border px-2 py-0.5 text-[0.65rem] capitalize text-muted-foreground">{scan.builder}</span>}
            {(scan.social_links || []).map((s) => <span key={s} className="rounded-full border border-primary/30 bg-primary/5 px-2 py-0.5 text-[0.65rem] capitalize text-primary">{s}</span>)}
          </div>
        </>
      )}
    </div>
  );
};

function Chip({ ok, label }) {
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[0.65rem] ${ok ? "border-[#22C55E]/40 text-[#22C55E]" : "border-border text-muted-foreground"}`}>
      {ok ? <CheckCircle2 className="h-3 w-3" /> : <XCircle className="h-3 w-3" />} {label}
    </span>
  );
}
